import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppTheme } from '../../contexts/ThemeContext';
// 404 Not Found Component with app styling
const NotFound = () => {
  const { theme } = useAppTheme();

  const navigate = useNavigate();

  const styles = {
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      backgroundColor: theme.colors.background.main,
      color: theme.colors.text.primary,
      fontFamily: theme.fontFamily.primary,
      padding: theme.spacing.lg,
    },
    errorCard: {
      backgroundColor: theme.colors.background.modal,
      borderRadius: theme.borderRadius.lg,
      padding: theme.spacing.xl,
      maxWidth: '600px',
      width: '100%',
      border: `1px solid ${theme.colors.border}`,
      boxShadow: theme.shadows.modal,
    },
    errorIcon: {
      fontSize: '48px',
      marginBottom: theme.spacing.md,
      color: theme.colors.warning,
    },
    errorTitle: {
      fontSize: theme.fontSize.title,
      fontWeight: theme.fontWeight.semibold,
      marginBottom: theme.spacing.sm,
      color: theme.colors.text.primary,
    },
    errorSubtitle: {
      fontSize: theme.fontSize.xl,
      color: theme.colors.text.secondary,
      marginBottom: theme.spacing.lg,
      lineHeight: '1.5',
    },
    errorCode: {
      backgroundColor: theme.colors.background.sidebar,
      borderRadius: theme.borderRadius.md,
      padding: theme.spacing.md,
      marginBottom: theme.spacing.lg,
      border: `1px solid ${theme.colors.border}`,
      fontFamily: theme.fontFamily.monospace,
      fontSize: theme.fontSize.md,
      color: theme.colors.warning,
      textAlign: 'center',
    },
    buttonContainer: {
      display: 'flex',
      gap: theme.spacing.sm,
      justifyContent: 'center',
    },
    button: {
      backgroundColor: theme.colors.background.button,
      color: theme.colors.text.primary,
      border: 'none',
      borderRadius: theme.borderRadius.md,
      padding: `${theme.spacing.sm} ${theme.spacing.lg}`,
      fontSize: theme.fontSize.md,
      fontWeight: theme.fontWeight.medium,
      cursor: 'pointer',
      transition: theme.transitions.fast,
    },
    buttonSecondary: {
      backgroundColor: 'transparent',
      color: theme.colors.text.secondary,
      border: `1px solid ${theme.colors.border}`,
    },
    buttonHover: {
      backgroundColor: theme.colors.background_hover.button,
    },
    buttonSecondaryHover: {
      backgroundColor: theme.colors.background.sidebar,
      color: theme.colors.text.primary,
    },
    helpText: {
      fontSize: theme.fontSize.md,
      color: theme.colors.text.muted,
      marginTop: theme.spacing.lg,
      textAlign: 'center',
      lineHeight: '1.4',
    },
    suggestions: {
      marginTop: theme.spacing.md,
      fontSize: theme.fontSize.md,
      color: theme.colors.text.muted,
    },
    suggestionList: {
      listStyle: 'none',
      padding: 0,
      margin: `${theme.spacing.sm} 0 0 0`,
    },
    suggestionItem: {
      marginBottom: theme.spacing.xs,
    },
  };

  const handleGoHome = () => {
    navigate('/');
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div style={styles.container}>
      <div style={styles.errorCard}>
        <div style={styles.errorIcon}>🔍</div>
        <h1 style={styles.errorTitle}>404 Not Found</h1>
        <p style={styles.errorSubtitle}>The page you're looking for doesn't exist or has been moved.</p>

        <div style={styles.buttonContainer}>
          <button
            style={styles.button}
            onClick={handleGoHome}
            onMouseEnter={(e) => Object.assign(e.target.style, styles.buttonHover)}
            onMouseLeave={(e) => Object.assign(e.target.style, styles.button)}
          >
            Go Home
          </button>
          <button
            style={{ ...styles.button, ...styles.buttonSecondary }}
            onClick={handleGoBack}
            onMouseEnter={(e) => Object.assign(e.target.style, styles.buttonSecondaryHover)}
            onMouseLeave={(e) => Object.assign(e.target.style, { ...styles.button, ...styles.buttonSecondary })}
          >
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
